"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuItem = require("./MenuItem.styled");

var _Icon = require("../Icon");

var _spacing = require("../../system/spacing.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var MenuItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MenuItem, _PureComponent);

  function MenuItem(props) {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).call(this, props));

    _this.updateChildren = function () {
      var children = _this.props.children;

      if (children && children.length > 1) {
        var childrenWithoutIcon = children.slice(); // Icon

        if (children[0].type === _Icon.Icon) {
          childrenWithoutIcon.splice(0, 1);

          _this.setState({
            icon: children[0]
          });
        }

        _this.setState({
          childrenWithoutIcon: childrenWithoutIcon
        });
      }
    };

    _this.onMenuItemClick = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;
      if (!disabled && onClick) onClick(event);
    };

    _this.onMenuItemMouseEnter = function (event) {
      var _this$props2 = _this.props,
          onMouseEnter = _this$props2.onMouseEnter,
          disabled = _this$props2.disabled;
      if (!disabled && onMouseEnter) onMouseEnter(event);
    };

    _this.onMenuItemMouseLeave = function (event) {
      var _this$props3 = _this.props,
          onMouseLeave = _this$props3.onMouseLeave,
          disabled = _this$props3.disabled;
      if (!disabled && onMouseLeave) onMouseLeave(event);
    };

    _this.state = {
      icon: null,
      childrenWithoutIcon: null
    };
    return _this;
  }

  _createClass(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateChildren();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var children = this.props.children;

      if (prevProps.children !== children) {
        this.updateChildren();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          children = _this$props4.children,
          selected = _this$props4.selected,
          rest = _objectWithoutProperties(_this$props4, ["id", "children", "selected"]);

      var _this$state = this.state,
          icon = _this$state.icon,
          childrenWithoutIcon = _this$state.childrenWithoutIcon;
      return _react.default.createElement(_MenuItem.StyledMenuItem, _extends({}, rest, {
        onClick: this.onMenuItemClick,
        id: id,
        selected: selected,
        hasIcon: !!icon
      }), _react.default.createElement(_MenuItem.StyledMenuItemIconWrapper, null, icon), _react.default.createElement(_MenuItem.StyledChildrenWrapper, null, childrenWithoutIcon || children));
    }
  }]);

  return MenuItem;
}(_react.PureComponent);
/**
 * Definition of default values for component props
 */


exports.MenuItem = MenuItem;
MenuItem.defaultProps = {
  color: undefined,
  backgroundColor: undefined,
  padding: undefined,
  inset: undefined,
  disabled: false,
  selected: false,
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  className: undefined,
  id: undefined
};
MenuItem.propTypes = {
  children: _propTypes.default.any.isRequired,
  color: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,

  /** padding only if you need a specific, none themed padding */
  padding: _propTypes.default.string,

  /** padding defined by spacing system */
  inset: _spacing.insetPropType,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  className: _propTypes.default.string,
  id: _propTypes.default.string
};